var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(-252 -551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5146",
    "data-name": "Rectangle 5146",
    transform: "translate(252 551)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-restore",
    d: "M17.969,6A13.181,13.181,0,0,0,4.9,17.663L3.429,16.2a1.1,1.1,0,1,0-1.551,1.551l3.291,3.291a1.1,1.1,0,0,0,1.551,0l3.291-3.291A1.1,1.1,0,1,0,8.46,16.2L7.134,17.523a10.945,10.945,0,1,1,1.06,6.629,1.1,1.1,0,1,0-1.954,1A13.167,13.167,0,1,0,17.969,6Zm0,9.509a3.649,3.649,0,0,0-2.74,1.169,3.835,3.835,0,0,0,0,4.977,3.8,3.8,0,0,0,5.48,0,3.835,3.835,0,0,0,0-4.977A3.649,3.649,0,0,0,17.969,15.509Zm0,2.194a1.317,1.317,0,0,1,1.1.431,1.647,1.647,0,0,1,0,2.063,1.317,1.317,0,0,1-1.1.431,1.317,1.317,0,0,1-1.1-.431,1.647,1.647,0,0,1,0-2.063A1.317,1.317,0,0,1,17.969,17.7Z",
    transform: "translate(251.455 548)",
    fill: "#fd581f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ba193d257304a338ce399a3295099e8f.svg";
export { ForwardRef as ReactComponent };